module.exports = __webpack_public_path__ + "img/jack_o_lantern.2e65cd9f.gif";